/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import PrettyPrintJson from 'components/pretty-print-json';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourceDataPopover = ({ resource, isOpen, close }) => {
    
    if (!resource || !isOpen) {
        return null;
    }

    return (
        <Modal title="Resource JSON Data" isVisible={isOpen} close={close}>
            <Box padding='large'>
                <PrettyPrintJson data={resource.data} />
            </Box>
        </Modal>
    );

};

export default ResourceDataPopover;
